import { Box, IconButton, Link, Paper, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useIntl } from 'react-intl'
import { messages } from '../../messages'
import { JourneyWaypoint } from '../plannerTypes'
import { PlannerAction } from '../state/journeyPlannerReducer'

type WaypointSectionProps = {
  waypoint: JourneyWaypoint
  waypointIndex: number
  waypointDisplayNumber: number
  dispatch: React.Dispatch<PlannerAction>
  onAddWaypointBefore?: () => void
  onAddWaypointAfter?: () => void
  onDelete?: () => void
}

const WaypointSection = ({
  waypoint,
  waypointIndex,
  waypointDisplayNumber,
  dispatch,
  onAddWaypointBefore,
  onAddWaypointAfter,
  onDelete,
}: WaypointSectionProps) => {
  const { formatMessage } = useIntl()

  const handleRemoveWaypoint = () => {
    if (onDelete) {
      onDelete()
    } else {
      dispatch({ type: 'REMOVE_WAYPOINT', waypointIndex })
    }
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        my: 2,
        borderStyle: 'dashed',
        borderColor: 'grey.400',
        bgcolor: 'grey.50',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {formatMessage(messages.waypointNumber, { number: waypointDisplayNumber })}
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {waypoint.locationName || ''}
          </Typography>
          <IconButton
            onClick={handleRemoveWaypoint}
            color="error"
            size="small"
            aria-label="Remove waypoint"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
          {onAddWaypointBefore && (
            <Link
              component="button"
              variant="body2"
              onClick={onAddWaypointBefore}
              sx={{ cursor: 'pointer', color: 'primary.main' }}
            >
              {formatMessage(messages.addWaypointBefore)}
            </Link>
          )}
          {onAddWaypointAfter && (
            <Link
              component="button"
              variant="body2"
              onClick={onAddWaypointAfter}
              sx={{ cursor: 'pointer', color: 'primary.main' }}
            >
              {formatMessage(messages.addWaypointAfter)}
            </Link>
          )}
        </Box>
      </Box>

      {waypoint.address && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {formatMessage(messages.address)}: {waypoint.address}
        </Typography>
      )}
    </Paper>
  )
}

export default WaypointSection
